import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText, renderStandardPictureElement } from "../../../../utils";

const articleTeaserData = {
    title: "Lorem ipsum dolor sit amet, consectetur adipis",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    description: getDummyText(300),
    category: "Lorem Ipsum",
    linkUrl: "#",
};

export default {
    title: "Website/Partial Templates/Teaser/Article",
};

const renderArticleTeaserImage = () => {
    return html`${renderStandardPictureElement({
        width: 585,
        height: 330,
    })}`;
};

const Template = () => {
    return html`
        <article class="ux-iws-teaser-article">
            <div class="ux-iws-teaser-article__image-container">
                ${renderArticleTeaserImage()}
            </div>
            <div class="ux-iws-teaser-article__content-container">
                <div class="ux-iws-teaser-article__info-container">
                    <ux-tag disabled> ${articleTeaserData.category} </ux-tag>
                    <h4
                        class="ux-text-title-teaser ux-u-text-bold ux-u-margin-top-10 ux-u-margin-bottom-5"
                    >
                        ${articleTeaserData.title}
                    </h4>
                    <ux-text-lines-limit
                        text-lines-s="3"
                        text-lines-m="3"
                        text-lines-l="2"
                        text-lines-xl="2"
                    >
                        <p
                            class="ux-text-normal ux-u-text-bold ux-u-margin-top-5 ux-u-margin-bottom-0"
                        >
                            ${articleTeaserData.description}
                        </p>
                    </ux-text-lines-limit>
                </div>
                <div class="ux-iws-teaser-article__cta-container">
                    <a
                        href="${articleTeaserData.linkUrl}"
                        class="ux-button ux-button--icon-only"
                        title="${articleTeaserData.title}"
                        aria-label="${articleTeaserData.title}"
                        role="button"
                        ><ux-icon name="chevron-right"></ux-icon
                    ></a>
                </div>
            </div>
        </article>
    `;
};

export const Default = Template.bind({});

const TemplateList = () => {
    const teaserItems = [];

    for (let i = 0; i < 5; i++) {
        teaserItems.push(Template());
    }

    return html` <div>${teaserItems.map((item) => item)}</div> `;
};

export const List = TemplateList.bind({});
